import React, { useState, useContext, useEffect } from 'react';
import SchedulingContext from '../Contexts/SchedulingContext';
import { isEmpty } from 'lodash';
import { Modal } from '@superops/ui-design-system';
import { CustomModal, SelectionSheet } from '@nile/components/src';
import SelectTechnicianContainer from '../Containers/SelectTechnicianContainer';
import DispatcherCalendar from '../Containers/DispatcherCalendar';
import TechnicianSelectionContainer from '../Containers/TechnicianSelectionContainer';
import styled from 'styled-components';

const DispatcherViewStyles = styled.div`
  height: 100%;
  .selection-sheet {
    min-width: 400px;
    width: 100%;
    max-width: 400px;
    height: 100% !important;
    background: #f7f7fd !important;
    padding: 20px 20px 0 20px !important;
  }
  .scroll-in {
    height: calc(100vh - 290px);
  }

  .selection-sheet-wrapper {
    width: ${(props) => (props?.open ? '100%' : '0')};
    max-width: ${(props) => (props?.open ? '400px' : '0')};
    overflow: hidden;
    transition: all 0.2s ease-out;
    min-width: ${(props) => (props?.open ? '400px' : '0px')};
    .Superops-ResourceItem__Container.Superops-ResourceItem--gutterMd {
      min-height: unset;
      padding: 5px 5px;
    }
    .Superops-Heading.Superops-Heading--sizeTertiary.Superops-Heading--weightBold {
      margin-bottom: 10px;
    }
  }
`;

const DispatcherView = () => {
  const schedulingContext = useContext(SchedulingContext);
  const [
    selectTechnicianModalActive,
    setSelectTechnicianModalActive
  ] = useState();

  useEffect(() => {
    if (isEmpty(selectedDispatcherTechnicians)) {
      setSelectTechnicianModalActive(true);
    }
  }, []);

  const {
    selectedDispatcherTechnicians,
    setSelectedDispatcherTechnicians
  } = schedulingContext;

  if (isEmpty(selectedDispatcherTechnicians)) {
    return (
      <>
        <CustomModal open={selectTechnicianModalActive}>
          <SelectTechnicianContainer />
        </CustomModal>
      </>
    );
  }
  return (
    <DispatcherViewStyles
      className="flex fhp w100"
      id="dispatcher-wrapper"
      open={schedulingContext?.technicianSheetActive}
    >
      <div className="selection-sheet-wrapper">
        <TechnicianSelectionContainer />
      </div>
      <DispatcherCalendar />
    </DispatcherViewStyles>
  );
};

export default DispatcherView;
